import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { BUSINESS, telHref } from "../lib/business";

const BULLETS = [
    "Kayseri tesisatçı arayan ev ve iş sahiplerine 7/24 hizmet",
    "Modern ekipman: termal kamera, akustik dinleme, robotik spiral",
    "Lisanslı su tesisatçısı ekibi, sigortalı ve garantili işçilik",
    "Şeffaf fiyat: işe başlamadan önce net teklif, sürpriz ücret yok",
    "Kayseri merkez ve tüm ilçeler — Melikgazi, Kocasinan, Talas, İncesu, Hacılar",
];

export const About = () => {
    return (
        <section
            id="hakkinda"
            data-testid="about-section"
            className="relative py-20 sm:py-28 bg-[#F8FAFC] border-y border-slate-200"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-start">
                <div className="lg:col-span-5">
                    <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#0055FF]">
                        Hakkımızda
                    </div>
                    <h2 className="mt-3 font-black tracking-tighter text-slate-900 text-3xl sm:text-4xl lg:text-5xl leading-[1.02]">
                        Kayseri'de <span className="text-[#0055FF]">güvenilir tesisatçı</span>.
                    </h2>
                </div>
                <div className="lg:col-span-7 space-y-5 text-slate-700 text-base sm:text-lg leading-relaxed">
                    <p>
                        <strong className="text-slate-900">{BUSINESS.name}</strong>, Kayseri ve çevresinde uzun yıllardır
                        faaliyet gösteren bir <strong className="text-slate-900">su tesisatçısı</strong> servisidir. Tıkanıklık açma,
                        su kaçağı tespiti, kombi ve petek tamiri ile banyo-mutfak tesisatı kurulum işlerinde
                        binlerce iş tamamladık. Her <strong className="text-slate-900">tesisatçı</strong> çağrısına aynı titizlikle yaklaşıyor;
                        evinizde kırıp dökmeden, temiz ve hızlı çalışıyoruz.
                    </p>
                    <p>
                        Acil su tesisatçısı ihtiyaçlarınızda gece-gündüz, hafta sonu ya da resmi tatil farkı olmadan
                        7/24 ulaşılabiliriz. Kayseri içinde ortalama 30 dakika varış süremiz, yapılan tüm işlere
                        verdiğimiz işçilik garantimiz ve sabit-şeffaf fiyat politikamız bizi şehirde en çok tercih edilen
                        tesisatçılardan biri yapıyor.
                    </p>

                    <ul className="grid sm:grid-cols-2 gap-3 pt-2">
                        {BULLETS.map((b, i) => (
                            <motion.li
                                key={i}
                                initial={{ opacity: 0, x: -10 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.4, delay: i * 0.05 }}
                                className="flex items-start gap-2 text-[15px] text-slate-800"
                            >
                                <CheckCircle2 className="w-5 h-5 text-[#0055FF] flex-shrink-0 mt-0.5" strokeWidth={2.5} />
                                <span>{b}</span>
                            </motion.li>
                        ))}
                    </ul>

                    <div className="pt-4">
                        <a
                            href={telHref}
                            data-testid="about-call-btn"
                            className="inline-flex items-center gap-2 rounded-full bg-slate-900 hover:bg-slate-800 text-white px-5 py-3 text-sm font-bold transition-all hover:scale-[1.03]"
                        >
                            Tesisatçı için hemen ara → {BUSINESS.phonePretty}
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
